export const EVENT_ACTION_NAV_LOGIN_CLICK = 'R1_AUTH_GLOBAL_NAV_LOGIN_CLICK';
